import React, { Component } from "react";
import ArticleModal from "../../../../../common/custom-form/article-modal-form.component";
import DebitorModal from "../../../../../common/custom-form/debitor-modal-form.component";
import Icon from "../../../../../icon";
class MappingInformationIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
            , showModalForm: false
        }
    }

    componentDidMount() {

    }

    handleShow() {
        this.setState({
            show: true
            , showModalForm: true
        });
    }

    handleClose = (val) => {
        this.setState({
            showModalForm: val
        });
    }

    render() {
        const articleId = this.props.mappingInformationList?.datatable[0]?.dataItem[0]?.ArticleId;
        const debitorId = this.props.mappingInformationList?.datatable[0]?.dataItem[0]?.DebitorId;
        return (
            <>
                <Icon
                    name="circle-info-reg"
                    size="18px"
                    customClassName="icon-nav"
                    containerClass="info-container"
                    onClick={this.handleShow.bind(this)}
                />

                {this.props.iconName === "article-icon" ? (
                    <ArticleModal
                        showModalForm={this.state.showModalForm}
                        handleClose={this.handleClose}
                        mappingInformationList={this.props.mappingInformationList}
                        articleId={articleId}
                        isViewing={true}
                        handleShow={this.handleShow}
                    />
                ) : (
                    <DebitorModal
                        showModalForm={this.state.showModalForm}
                        mappingInformationList={this.props.mappingInformationList}
                        handleClose={this.handleClose}
                        debitorId={debitorId}
                        isViewing={true}
                    />
                )}
            </>
        );
    }
}

export default (MappingInformationIcon);

